<template>
  <div>
    <div class="content" v-show="isCreate">
      <el-form ref="form" class="form" :model="form" :rules="rules">
        <span class="fastReg">快速注册</span>
        <el-form-item prop="name">
          <el-input
            class="inputPad"
            style="width:500px"
            placeholder="请输入真实姓名"
            maxlength="50"
            v-model.trim="form.name"
          ></el-input>

          <span class="inputBe">姓名</span>
        </el-form-item>
        <el-form-item prop="mobile">
          <el-input
            class="inputPad"
            placeholder="请输入手机号"
            maxlength="11"
            v-model="form.mobile"
          ></el-input>
          <!-- <el-select v-model="select" class="inputBe2">
            <el-option v-for="(v, key) in country" :key="key" :label="v.name" :value="v.code"></el-option>
          </el-select>-->
          <span class="inputBe">
            +86
            <img
              src="../../../../assets/images/arrows.png"
              style="display:inline;padding-left:5px;padding-bottom:2px;"
              alt
            />
          </span>
        </el-form-item>
        <div v-show="false">
          <div class="testNumber" @click="goIsPhone">立即注册</div>
        </div>
        <div v-show="true">
          <el-form-item prop="inputAuthCode">
            <div class="inputAuthCodeBox">
              <el-input
                maxlength="6"
                class="inputAuthCode"
                placeholder="请输入短信验证码"
                v-model="form.inputAuthCode"
              ></el-input>
              <div class="countDown" v-show="show" @click="getCode">
                发送验证码
              </div>
              <div class="countDown" ref="countDown" v-show="!show">
                {{ second }}秒
              </div>
            </div>
          </el-form-item>
          <div class="testNumber" @click="goPage">验证手机号并继续</div>
        </div>
      </el-form>
      <el-dialog
        title="提示"
        :visible.sync="regSourceShow"
        width="600px"
        show-divider
        show-shadow
        :close-on-click-modal="false"
        :before-close="handleClose"
        custom-class="el-dialog--customize"
      >
        <span>{{ dialogContent }}</span>
        <span slot="footer">
          <el-button size="mini" type="default-mini" @click="regSourceReturn"
            >取消</el-button
          >
          <el-button size="mini" type="primary-font-mini" @click="regSourceGo"
            >确定</el-button
          >
        </span>
      </el-dialog>
    </div>

    <div v-show="isPhoneCompany">
      <RepeatPhone
        :companyList="companyList"
        @approval="approval"
        @isExist="isExist"
      ></RepeatPhone>
    </div>
    <div v-show="isNewCompany">
      <RegNewCompany @approval="approval" @isExist="isExist"></RegNewCompany>
    </div>
    <div v-show="isCompanyBeenReg">
      <CompanyBeenReg
        @approval="approval"
        @isExist="isExist"
        @next="nextViewFn"
      ></CompanyBeenReg>
    </div>
    <div v-show="isApprovaling">
      <Approvaling @approval="approval" @isExist="isExist"></Approvaling>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import countryCodes from "../../../../common/countryCode";
import RepeatPhone from "./repeatPhone";
import CompanyBeenReg from "./companyBeenReg";
import RegNewCompany from "./regNewCompany";
import Approvaling from "./approvaling";
import { getCheckContact, getPlatform, getPmcAdress } from "@/api/register";
export default {
  props: ["flag"],
  data() {
    const mobileRules = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const inputAuthCodeRules = (rule, value, callback) => {
      if (!/^\d{6}$/.test(value)) {
        callback(new Error("请输入六位数字验证码"));
      } else {
        callback();
      }
    };
    return {
      //缓存跳转数据
      jumpObj: {},
      //弹出框开始
      regSourceShow: false,
      agreeBtn: false,
      dialogContent: "",
      //弹出框结束
      //message高度
      messageHeight: null,
      mobile: "",
      name: "",
      show: true,
      second: "",
      timer: null,
      code: "",
      boll: false,
      country: countryCodes,
      isPhone: false,
      isNewCompany: false,
      isPhoneCompany: false,
      isCompanyBeenReg: false,
      isApprovaling: false,
      isCreate: true,
      rules: {
        name: [
          {
            required: true,
            message: "请输入真实姓名",
            trigger: "blur"
          },
          // { max: 50, message: "数量在50个汉字以下", trigger: "blur" },
          {
            required: true,
            pattern: /^[^&]+$/,
            message: "不可输入&",
            trigger: ["blur"]
          }
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: mobileRules, trigger: "blur" }
        ],
        inputAuthCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { validator: inputAuthCodeRules, trigger: ["blur", "change"] }
        ]
      },
      form: {
        name: "",
        mobile: "",
        inputAuthCode: ""
      },
      select: "86",
      companyList: [],
      personInfo: {
        name: "",
        mobile: ""
      },
      isCode: false
    };
  },
  components: {
    RepeatPhone,
    CompanyBeenReg,
    RegNewCompany,
    Approvaling
  },
  watch: {
    flag: function(value) {
      if (value) {
        console.log(value, "打印value");
        this.isPhone = false;
        this.isNewCompany = false;
        this.isPhoneCompany = false;
        this.isCompanyBeenReg = false;
        this.isCreate = true;
        this.$emit("toFlag");
      }
    }
  },
  created() {
    // getPmcAdress({ addressCode: "100000" }).then(res => {
    //   console.log(res, "区域");
    // });
  },
  mounted() {
    this.getBrowserHeight();
  },
  methods: {
    //弹窗
    handleClose(done) {
      done();
    },
    //弹窗取消
    regSourceReturn() {
      this.regSourceShow = false;
      this.$router.push({
        path: "/"
      });
    },
    //弹窗确定
    regSourceGo() {
      this.regSourceShow = false;
      if (this.jumpObj.data.code === "0") {
        if (this.jumpObj.data.data.regSource) {
          //物资
          if (this.jumpObj.data.data.regSource === "0") {
            if (this.jumpObj.data.data.supplierState === "0") {
              this.$router.push({
                path: "/maReady"
              });
              sessionStorage.setItem(
                "localMa",
                JSON.stringify({
                  check_page: "2",
                  companyName: this.jumpObj.data.data.companyName,
                  supplierCode: this.jumpObj.data.data.supplierCode
                })
              );
              if (this.jumpObj.data.data.point) {
                this.$message({
                  message: this.jumpObj.data.data.point,
                  type: "warning",
                  offset: document.body.clientHeight / 2 - 21
                });
              }
              return false;
            } else if (this.jumpObj.data.data.supplierState === "2") {
              this.$router.push({
                path: "/maReady"
              });
              sessionStorage.setItem(
                "localMa",
                JSON.stringify({
                  check_page: "4",
                  companyName: this.jumpObj.data.data.companyName,
                  success: true,
                  supplierCode: this.jumpObj.data.data.supplierCode
                })
              );
              if (this.jumpObj.data.data.point) {
                this.$message({
                  message: this.jumpObj.data.data.point,
                  type: "warning",
                  offset: document.body.clientHeight / 2 - 21
                });
              }
              return false;
            } else if (this.jumpObj.data.data.supplierState === "4") {
              this.$router.push({
                path: "/maReady"
              });
              sessionStorage.setItem(
                "localMa",
                JSON.stringify({
                  check_page: "4",
                  companyName: this.jumpObj.data.data.companyName,
                  success: false,
                  supplierCode: this.jumpObj.data.data.supplierCode
                })
              );
              if (this.jumpObj.data.data.point) {
                this.$message({
                  message: this.jumpObj.data.data.point,
                  type: "warning",
                  offset: document.body.clientHeight / 2 - 21
                });
              }
              return false;
            }

            //电子商城这里加
          }
          //装备
          if (this.jumpObj.data.data.regSource === "1") {
            if (this.jumpObj.data.data.supplierState === "0") {
              this.$router.push({
                path: "/eqReady"
              });
              sessionStorage.setItem(
                "localEq",
                JSON.stringify({
                  check_page: "2",
                  companyName: this.jumpObj.data.data.companyName,
                  supplierCode: this.jumpObj.data.data.supplierCode
                })
              );
              if (this.jumpObj.data.data.point) {
                this.$message({
                  message: this.jumpObj.data.data.point,
                  type: "warning",
                  offset: document.body.clientHeight / 2 - 21
                });
              }
              return false;
            } else if (this.jumpObj.data.data.supplierState === "2") {
              this.$router.push({
                path: "/eqReady"
              });
              sessionStorage.setItem(
                "localEq",
                JSON.stringify({
                  check_page: "4",
                  companyName: this.jumpObj.data.data.companyName,
                  success: true,
                  supplierCode: this.jumpObj.data.data.supplierCode
                })
              );
              if (this.jumpObj.data.data.point) {
                this.$message({
                  message: this.jumpObj.data.data.point,
                  type: "warning",
                  offset: document.body.clientHeight / 2 - 21
                });
              }
              return false;
            } else if (this.jumpObj.data.data.supplierState === "4") {
              this.$router.push({
                path: "/eqReady"
              });
              sessionStorage.setItem(
                "localEq",
                JSON.stringify({
                  check_page: "4",
                  companyName: this.jumpObj.data.data.companyName,
                  success: false,
                  supplierCode: this.jumpObj.data.data.supplierCode
                })
              );
              if (this.jumpObj.data.data.point) {
                this.$message({
                  message: this.jumpObj.data.data.point,
                  type: "warning",
                  offset: document.body.clientHeight / 2 - 21
                });
              }
              return false;
            }

            //电子商城这里加
          }
          //分包
          if (this.jumpObj.data.data.regSource === "2") {
            if (this.jumpObj.data.data.supplierState === "0") {
              this.$router.push({
                path: "/subReady"
              });
              this.$eventBus.$emit("localSub", {
                check_page: "2",
                companyName: this.jumpObj.data.data.companyName,
                supplierCode: this.jumpObj.data.data.supplierCode
              });

              if (this.jumpObj.data.data.point) {
                this.$message({
                  message: this.jumpObj.data.data.point,
                  type: "warning",
                  offset: document.body.clientHeight / 2 - 21
                });
              }
              return false;
            } else if (this.jumpObj.data.data.supplierState === "2") {
              this.$router.push({
                path: "/subReady"
              });
              this.$eventBus.$emit("localSub", {
                check_page: "4",
                success: true,
                companyName: this.jumpObj.data.data.companyName,
                supplierCode: this.jumpObj.data.data.supplierCode
              });
              if (this.jumpObj.data.data.point) {
                this.$message({
                  message: this.jumpObj.data.data.point,
                  type: "warning",
                  offset: document.body.clientHeight / 2 - 21
                });
              }
              return false;
            } else if (this.jumpObj.data.data.supplierState === "4") {
              this.$router.push({
                path: "/subReady"
              });
              this.$eventBus.$emit("localSub", {
                check_page: "4",
                success: false,
                companyName: this.jumpObj.data.data.companyName,
                supplierCode: this.jumpObj.data.data.supplierCode
              });
              if (this.jumpObj.data.data.point) {
                this.$message({
                  message: this.jumpObj.data.data.point,
                  type: "warning",
                  offset: document.body.clientHeight / 2 - 21
                });
              }
              return false;
            }

            //电子商城这里加
          }
        } else {
          if (this.jumpObj.data.data.supplierNames.length > 0) {
            this.isPhoneCompany = true;
            this.isNewCompany = false;
            this.isCompanyBeenReg = false;
            this.companyList = this.jumpObj.data.data.supplierNames;

            this.$eventBus.$emit("msg", this.form);
            if (this.jumpObj.data.data.point) {
              this.$message({
                message: this.jumpObj.data.data.point,
                type: "warning",
                offset: document.body.clientHeight / 2 - 21
              });
            }
          } else {
            this.isNewCompany = true;
            this.isCompanyBeenReg = false;
            this.isPhoneCompany = false;
            this.$eventBus.$emit("msg", this.form);
            if (this.jumpObj.data.data.point) {
              this.$message({
                message: this.jumpObj.data.data.point,
                type: "warning",
                offset: document.body.clientHeight / 2 - 21
              });
            }
          }
        }
        this.isCreate = false;
      }
    },
    //获取浏览器视口高度
    getBrowserHeight() {
      this.messageHeight = (window.innerHeight - 40) / 2;
      console.log(window.innerHeight, "高度");
    },
    //时间戳加0方法
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    nextViewFn() {
      this.$emit("nextPerfect", { name });
    },
    getCode() {
      this.$refs.countDown.style.backgroundColor = "rgba(242, 242, 242, 1)";
      this.$refs.countDown.style.color = "rgba(153, 153, 153, 1)";
      this.$refs.countDown.style.cursor = "no-drop";
      const TIME_COUNT = 59;
      this.second = TIME_COUNT;
      this.show = false;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.second > 0 && this.second <= TIME_COUNT) {
          this.second--;
        } else {
          this.show = true;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
      getPlatform(`mobile=${this.form.mobile}`)
        .then(res => {
          this.isCode = false;
          if (res.data.code === "0") {
            if (res.data.message.includes("成功")) {
              this.isCode = true;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.second = 59;
              this.$message({
                message: res.data.message,
                type: "error",
                offset: this.messageHeight
              });
            }
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.second = 59;
            this.$message({
              message: res.data.message,
              type: "error",
              offset: this.messageHeight
            });
          }
        })
        .catch(errMessage => {
          this.show = true;
          clearInterval(this.timer);
          this.second = 59;
          // this.$message({
          //   message: errMessage,
          //   type: "error"
          // });
        });
    },
    isExist({ flag, name }) {
      if (flag) {
        this.isCompanyBeenReg = flag;
        this.isNewCompany = false;
        this.isPhoneCompany = false;
        this.isCreate = false;
      } else {
        this.$emit("nextPerfect", { name });
      }
    },
    approval({ flag, name }) {
      console.log(flag, name);
      if (flag) {
        this.isApprovaling = flag;
        this.isNewCompany = false;
        this.isPhoneCompany = false;
        this.isCreate = false;
      } else {
        this.$emit("nextPerfect", { name });
      }
    },
    // 点击
    goIsPhone() {
      // if (!this.form.name || !/^1[3456789]\d{9}$/.test(this.form.mobile)) {
      // } else {
      //   this.isPhone = true;
      // }

      this.$refs.form.validateField("name", nameError => {
        this.$refs.form.validateField("mobile", mobileError => {
          if (!mobileError && !nameError) {
            this.isPhone = true;
          } else {
            return false;
          }
        });
      });
    },
    // 点击
    goPage() {
      this.$refs["form"].validate(valid => {
        if (valid) {
        } else {
          this.$nextTick(() => {
            const ele =
              this.$el.querySelector(".is-error") ||
              this.$el.querySelector(".is-required");
            console.log(ele);
            console.log(ele.offsetTop);
            if (ele) {
              // 获取到所在Row的offsetTop值
              window.scrollTo(
                0,
                ele.offsetTop || ele.parentNode.parentNode.parentNode.offsetTop
              );
            }
          });
          return false;
        }
      });
      if (
        !this.form.name ||
        !/^1[3456789]\d{9}$/.test(this.form.mobile) ||
        !/^\d{6}$/.test(this.form.inputAuthCode)
      ) {
        // this.$message({
        //   showClose: true,
        //   message: "请输入正确信息",
        //   type: "warning"
        // });
      } else {
        // start 需要验证手机验证码时打开
        // this.isNewCompany = true;
        // this.isCompanyBeenReg = false;
        // this.isPhoneCompany = false;
        // this.$eventBus.$emit("msg", this.form);
        // this.isCreate = false;
        // return false;
        // end

        //验证码接口好了以后打开start
        // if (!this.isCode) {
        //   this.$message({
        //     message: "请先获取验证码",
        //     type: "error"
        //   });
        //   return false;
        // }
        //验证码接口好了以后打开end

        //1113
        getCheckContact({
          name: this.form.name,
          inputAuthCode: this.form.inputAuthCode,
          mobile: this.form.mobile,
          isShowLoading: true,
          loadingMessage: "验证中,请稍等..."
        }).then(res => {
          if (res.data.code === "0") {
            sessionStorage.setItem(
              "querySupplierCode",
              JSON.stringify({
                supplierCode: res.data.data.supplierCode
              })
            );
            if (res.data.data.regSource) {
              this.jumpObj = {};
              this.jumpObj = res;
              // if (this.agreeBtn === false) {
              //   return false;
              // } else {
              //   this.getCheckContact();
              // }
              //物资
              if (res.data.data.regSource === "0") {
                if (res.data.data.supplierState === "0") {
                  this.regSourceShow = true;
                  this.dialogContent =
                    "您的物资供应商合作申请还未完成，请继续完善信息后进行提交";
                } else if (res.data.data.supplierState === "2") {
                  this.regSourceShow = true;
                  this.dialogContent =
                    "您的物资供应商合作申请正在审批中，点击确定查看";
                } else if (res.data.data.supplierState === "4") {
                  this.regSourceGo();
                }
              }
              //装备
              else if (res.data.data.regSource === "1") {
                if (res.data.data.supplierState === "0") {
                  this.regSourceShow = true;
                  this.dialogContent =
                    "您的装备供应商合作申请还未完成，请继续完善信息后进行提交";
                } else if (res.data.data.supplierState === "2") {
                  this.regSourceShow = true;
                  this.dialogContent =
                    "您的装备供应商合作申请正在审批中，点击确定查看";
                } else if (res.data.data.supplierState === "4") {
                  this.regSourceGo();
                }
              }
              //分包
              else if (res.data.data.regSource === "2") {
                if (res.data.data.supplierState === "0") {
                  this.regSourceShow = true;
                  this.dialogContent =
                    "您的分包商合作申请还未完成，请继续完善信息后进行提交";
                } else if (res.data.data.supplierState === "2") {
                  this.regSourceShow = true;
                  this.dialogContent =
                    "您的分包商合作申请正在审批中，点击确定查看";
                } else if (res.data.data.supplierState === "4") {
                  this.regSourceGo();
                }
              }
            } else {
              if (res.data.data.supplierNames.length > 0) {
                this.isPhoneCompany = true;
                this.isNewCompany = false;
                this.isCompanyBeenReg = false;
                this.companyList = res.data.data.supplierNames;

                this.$eventBus.$emit("msg", this.form);
                if (res.data.data.point) {
                  this.$message({
                    message: res.data.data.point,
                    type: "warning",
                    offset: document.body.clientHeight / 2 - 21
                  });
                }
              } else {
                this.isNewCompany = true;
                this.isCompanyBeenReg = false;
                this.isPhoneCompany = false;
                this.$eventBus.$emit("msg", this.form);
                if (res.data.data.point) {
                  this.$message({
                    message: res.data.data.point,
                    type: "warning",
                    offset: document.body.clientHeight / 2 - 21
                  });
                }
              }
              this.isCreate = false;
            }
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
html,
body {
  font-family: Arial;
  background-color: #f5f5f9;
  padding: 0px;
  margin: 0px;
  -webkit-font-smoothing: antialiased; /*让字体更润滑*/
  -moz-osx-font-smoothing: grayscale; /*让字体更润滑*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*禁止链接高亮*/
  -webkit-touch-callout: none; /*禁止链接长按弹出选项*/
}
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
input,
div {
  border: 0 none;
  border-radius: 0px;
  outline: none;
}
/* content */
.content {
  width: 1180px;
  min-height: calc(100vh - 290px);
  background: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 34px;
}
.fastReg {
  font-size: 20px;
  font-family: PingFang-SC;
  font-weight: 800;
  color: rgba(74, 74, 74, 1);
  line-height: 28px;
  display: block;
  padding-bottom: 20px;
}
.regUpload {
  width: 500px;
  height: 40px;
  background: rgba(255, 20, 47, 1);
  border-radius: 4px;
  position: absolute;
  top: 228px;
  left: 340px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  cursor: pointer;
}
.codeTxt {
  width: 370px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid rgba(204, 204, 204, 1);
  position: absolute;
  left: 340px;
  top: 208px;
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 40px;
}
.codeTxt input {
  color: rgba(74, 74, 74, 1);
}
.countDown {
  width: 110px;
  height: 40px;
  /* background: rgba(242, 242, 242, 1); */
  background-color: rgba(255, 20, 47, 1);
  border-radius: 4px;
  border: 1px solid rgba(204, 204, 204, 1);
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #fff;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  margin-left: 10px;
}
.testNumber {
  width: 500px;
  height: 40px;
  background: rgba(255, 20, 47, 1);
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  cursor: pointer;
  text-align: center;
  line-height: 40px;
}
.codeList li {
  width: 100%;
  height: 100%;
  line-height: 30px;
  padding: 0 10px;
  cursor: pointer;
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  /* line-height: 18px; */
}
.select {
  width: 67px;
  overflow: hidden;
  margin-top: -2px;
}
.codeList li:hover {
  background: #c7c9cc;
}
.codeList {
  position: absolute;
  left: -1px;
  border: 1px solid #ccc;
  border-top: 0;
  z-index: 99;
  background: #fff;
  width: 297px;
  height: 204px;
  overflow-y: scroll;
  border-radius: 0 0 5px 5px;
  padding: 0;
}
.inputAuthCode {
  width: 380px;
  margin: 0;
}

.codeInfo {
  width: 100%;
  height: 32px;
  padding-left: 10px;
}
.form {
  width: 500px;
}
.inputAuthCodeBox {
  display: flex;
}
/deep/.el-button.el-button--primary-font-mini {
  background-color: #ff142f;
  border-color: #ff142f;
}
/deep/.el-button.el-button--default-mini:hover {
  color: #ff142f;
}
</style>
<style scoped>
/deep/.el-input__inner {
  height: 40px;
  padding-left: 10px;
  line-height: 40px;
}
/deep/.el-input-group__prepend {
  background: rgba(255, 255, 255, 1);
  margin-bottom: 10px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}
/deep/.el-icon-caret-bottom {
  line-height: 3;
}
/deep/.el-input-group {
  position: relative;
}
/deep/.inputBe {
  position: absolute;
  /* z-index: 999; */
  width: 71px;
  height: 38px;
  background: transparent;
  border-right: 1px solid rgba(204, 204, 204, 1);
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  text-align: center;
  line-height: 40px;
  left: 1px;
  top: 1px;
}
/deep/.inputBe2 {
  position: absolute;
  /* z-index: 999; */
  width: 71px;
  height: 38px;
  background: #fff;
  border-right: 1px solid rgba(204, 204, 204, 1);
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  text-align: center;
  line-height: 40px;
  left: 0px;
}
/deep/.inputBe2 .el-input__inner:hover {
  border: 1px solid #dcdfe6;
}
/deep/.inputPad .el-input__inner {
  padding-left: 82px;
}
/deep/.el-select {
  border: 1px solid rgba(204, 204, 204, 1) !important;
}
</style>
